import { cn } from "@/utils/cn";
import { fieldInputClass, fieldInputErrorClass } from "./fieldStyles";

type Props = {
  id: string;
  label: string;
  value: unknown;
  onChange: (v: number | undefined) => void;
  error?: string;
};

export function FieldNumber({ id, label, value, onChange, error }: Props) {
  const str =
    typeof value === "number" && !Number.isNaN(value)
      ? String(value)
      : typeof value === "string"
        ? value
        : "";
  return (
    <div className="mb-6">
      <label htmlFor={id} className="choice-textarea-label">
        {label}
      </label>
      <input
        id={id}
        type="number"
        inputMode="decimal"
        className={cn(
          fieldInputClass,
          "max-w-xs [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
          error && fieldInputErrorClass
        )}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        value={str}
        onChange={(e) => {
          const t = e.target.value;
          if (t === "") {
            onChange(undefined);
            return;
          }
          const n = Number(t);
          onChange(Number.isFinite(n) ? n : undefined);
        }}
      />
      {error && <p id={`${id}-error`} className="choice-group__error" role="alert">{error}</p>}
    </div>
  );
}
